import React, { useEffect, useState } from 'react';
import "./Specialists.scss"
import ModalComponent from '../../UI/ModalComponent/ModalComponent';
import SpecialistsList from '../SpecialistsList/SpecialistsList';
import { useSelector } from 'react-redux';

const Specialists = () => {
    const specialists = useSelector(state => state.schedule.specialists);

    const getCountWord = (count) => {
        const lastTwoDigits = count % 100;
        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
            return count + ' специалистов';
        }

        const lastDigit = count % 10;
        if (lastDigit === 1) {
            return count + ' специалист';
        }
        if (lastDigit >= 2 && lastDigit <= 4) {
            return count + ' специалиста';
        }

        return count + ' специалистов';
    };

    return (
        <div className="specialists">
            <ModalComponent
                isSpecialistListModal={true}
                sidebar={true}
                button={<div className="specialists__button">Все специалисты</div>}>
                <div className="specialists__content">
                    <h3 className="specialists__content-title">Сотрудники <span>{getCountWord(specialists.length)}</span></h3>
                    
                    <SpecialistsList
                        specialists={specialists} />
                </div>
            </ModalComponent>
        </div>
    )
}

export default Specialists;